import { Building2 } from "lucide-react";

export const isInternal = (x) => !!(x?.is_internal || x?.source === "internal" || (x?.sources || []).some((s) => s.provider === "internal"));

export const InternalTag = ({ testid }) => (
  <span className="inline-flex shrink-0 items-center gap-1 rounded-full border border-[#D4AF37]/50 bg-[#D4AF37]/10 px-1.5 py-px text-[9px] font-semibold uppercase tracking-wider text-[#F3C649]" title="RPOPRO internal talent" data-testid={testid}><Building2 className="h-2.5 w-2.5" />Internal</span>
);
